import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    leadActionButton: {
      marginLeft: theme.spacing(2),
    },
  }),
);
